import React from "react";

export default function DisplayHeading({ as = "h1", children, className = "" }) {
  const Tag = as;
  return (
    <Tag
      className={[
        "text-4xl font-semibold leading-[1.05] tracking-display text-ink md:text-6xl lg:text-7xl",
        className,
      ].join(" ")}
    >
      {children}
    </Tag>
  );
}
